import {
  getObject,
  getList,
} from "@surya-digital/leo-ts-types";
import { Answer, AnswerDTO } from "../types/answer";
import { Count, CountDTO } from "./count";

export interface RankingResultV1DTO {
  answer: AnswerDTO;
  count: CountDTO[];
}

export class RankingResultV1 {
  readonly isRankingResultV1RankingResultV1: boolean = true;

  readonly answer: Answer;
  readonly count: Count[];


  constructor(
  answer: Answer, 
  count: Count[]
  ) {
    this.answer = answer;
    this.count = count;
  }

  static fromDTO(dto: RankingResultV1DTO): RankingResultV1 {
    const answer = Answer.fromDTO(getObject(dto, "answer", InvalidRankingResultV1AnswerError));
    const count = getList<CountDTO, Count>(
      dto,
      "count",
      Count.fromDTO,
      InvalidRankingResultV1CountError
    );
    return new RankingResultV1(
      answer,
      count
    );
  }

  toDTO(): RankingResultV1DTO {
    const dto: RankingResultV1DTO = {
        answer: this.answer.toDTO(),
        count: this.count.map((e: Count) => { return e.toDTO() })
    };
    return dto;
  }
  }

RankingResultV1.prototype.toString = function toString(): string {
  return `RankingResultV1(answer='${this.answer}',count='${this.count}')`;
};

export class InvalidRankingResultV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingResultV1Error";
  }
}
export class InvalidRankingResultV1AnswerError extends InvalidRankingResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingResultV1AnswerError";
  }
}

export class InvalidRankingResultV1CountError extends InvalidRankingResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingResultV1CountError";
  }
}
